import { currentEnv } from "../../Api/configs";

const API_GATEWAY_URL = currentEnv.chatWebSocket;

interface ChatEvent {
  type: string;
  data: any;
}

let socket: WebSocket | null = null;
let reconnectAttempts = 0;
const maxReconnectAttempts = 10;
const initialReconnectInterval = 2000;
let isManualDisconnect = false;

export const connectWebSocket = (
  accessToken: string,
  onMessage: (event: ChatEvent) => void
) => {
  isManualDisconnect = false;

  const connect = () => {
    if (reconnectAttempts >= maxReconnectAttempts) {
      console.error("Max reconnect attempts reached. Stopping reconnection.");
      return;
    }

    if (!socket || socket.readyState === WebSocket.CLOSED) {
      socket = new WebSocket(`${API_GATEWAY_URL}?accessToken=${accessToken}`);

      socket.onopen = () => {
        console.log("WebSocket connected");
        reconnectAttempts = 0;
      };

      socket.onmessage = (event) => {
        const data: ChatEvent = JSON.parse(event.data);
        onMessage(data);
      };

      socket.onerror = (error) => {
        console.error("WebSocket error", error);
      };

      socket.onclose = () => {
        console.log("WebSocket disconnected");
        if (!isManualDisconnect) {
          attemptReconnect(accessToken, onMessage);
        }
      };
    }
  };

  const attemptReconnect = (
    accessToken: string,
    onMessage: (event: ChatEvent) => void
  ) => {
    reconnectAttempts++;
    const reconnectInterval =
      initialReconnectInterval * Math.pow(2, reconnectAttempts - 1);
    const limitedInterval = Math.min(reconnectInterval, 30000);

    console.log(
      `Reconnecting... Attempt ${reconnectAttempts} in ${
        limitedInterval / 1000
      } seconds`
    );
    setTimeout(() => connectWebSocket(accessToken, onMessage), limitedInterval);
  };

  connect();

  // document.addEventListener("visibilitychange", () => {
  //   if (
  //     document.visibilityState === "visible" &&
  //     (!socket || socket.readyState === WebSocket.CLOSED)
  //   ) {
  //     console.log("Document visible. Reconnecting WebSocket.");
  //     connectWebSocket(accessToken, onMessage);
  //   } else if (document.visibilityState === "hidden" && socket) {
  //     console.log("Document hidden. Disconnecting WebSocket.");
  //     disconnectWebSocket();
  //   }
  // });
};

export const sendChatMessage = (
  chatId: string,
  userId: string,
  messageContent: string,
  accessToken: string,
  messageId: string
) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    const message = {
      action: "sendMessage",
      data: {
        chatId,
        userId,
        message: messageContent,
        accessToken,
        messageId,
      },
    };
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not open. Message not sent.");
  }
};

export const updateMessage = (
  chatId: string,
  messageId: string,
  updateType: "react" | "read" | "readAll",
  updateData: any,
  accessToken: string,
  messageContent: string
) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    const message = {
      action: "updateMessage",
      data: {
        chatId,
        messageId,
        type: updateType,
        updateData,
        accessToken,
        messageContent,
      },
    };
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not open. Update not sent.");
  }
};

export const deleteMessage = (
  chatId: string,
  messageId: string,
  deleteType: "deleteForUser" | "deleteForEveryone",
  deleteData: { userId?: string },
  accessToken: string
) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    const message = {
      action: "deleteMessage",
      data: {
        chatId,
        messageId,
        deleteType,
        ...deleteData,
        accessToken,
      },
    };
    socket.send(JSON.stringify(message));
  } else {
    console.error("WebSocket is not open. Delete action not sent.");
  }
};

export const disconnectWebSocket = () => {
  isManualDisconnect = true;
  if (socket) {
    socket.close();
    socket = null;
  }
};
